import React from 'react';
import { useIntl } from 'react-intl';
import { useFragment, graphql, useMutation } from 'react-relay/hooks';
import { Flexbox, Switch } from '@sonika-se/ui-kit/components';
export const EditEventIsAddition = (props) => {
    const { eventRef } = props;
    const intl = useIntl();
    const { id, isAddition } = useFragment(graphql `
      fragment EditEventIsAddition_event on Event {
        id
        isAddition
      }
    `, eventRef);
    const [updateEvent, updateEventLoading] = useMutation(graphql `
    mutation EditEventIsAdditionMutation($model: UpdateEventRequestInput!) {
      updateEvent(model: $model) {
        eventEdge {
          node {
            id
            isAddition
          }
        }
      }
    }
  `);
    return (<Flexbox align="center">
      <Switch disabled={updateEventLoading} checked={isAddition} label={intl.formatMessage({
            id: 'EventSettings.isAddition',
            defaultMessage: 'Är tillägg',
        })} onChange={() => {
            updateEvent({
                variables: {
                    model: {
                        id,
                        isAddition: !isAddition,
                    },
                },
            });
        }}/>
    </Flexbox>);
};
export default EditEventIsAddition;
